module.exports = __webpack_public_path__ + "img/program-talk_3.6e298572.jpg";